<div class="h-100 pointer-events-none" [ngStyle]="customStyle">
  <form
    [formGroup]="selectCountryForm"
    class="finxForm"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <div>
      <div class="mb-2">
        <label>{{ widgetConfig.attributes.widgetProperties.inputFieldSettings?.currencyLabel }}</label>
      </div>
      <finx-dropdown
        formControlName="currency"
        label="title"
        appendto="body"
        [options]="currencyCodes"
        [showAccountsListWithFlag]="showCurrencyFlags"
        [inputStyle]="currentCurrencyStyle"
        [value]="selectCountryForm.get('currency')?.value"
        (focusEvent)="updateStyles($event, 'currency')"
        (valueChange)="emitLatestValues()"
      ></finx-dropdown>
    </div>
    <div class="w-100">
      <div class="mb-2">
        <label>{{ widgetConfig.attributes.widgetProperties.inputFieldSettings?.countryLabel }}</label>
      </div>
      <finx-dropdown
        formControlName="country"
        label="title"
        appendto="body"
        [filter]="true"
        [filterBy]="'title'"
        [options]="countryList"
        [inputStyle]="currentCountryStyle"
        [showAccountsListWithFlag]="showCurrencyFlags"
        [value]="selectCountryForm.get('country')?.value"
        (focusEvent)="updateStyles($event, 'country')"
        (valueChange)="emitLatestValues()"
      ></finx-dropdown>
    </div>
    @if (!isSubmitTypeAsynchronous) {
    <div class="mx-0 p-0 mt-4 submit-button pointer-events-none">
      <finx-button
        type="button"
        (click)="onSubmit()"
        [labeltext]="continueButtonContent"
        class="continue-button pointer-events-none d-flex"
        [class.h-100]="!isAllowedGlobalStyling"
        [buttonStyle]="!isAllowedGlobalStyling ? continueButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100 mandatory-cta-button'"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
    }
  </form>
</div>
